import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import cx from 'classnames';
import IconSearch from 'react-icons/lib/fa/search';
import debounce from 'lodash.debounce';

import Input from '../../common/Input/Input';
import Spinner from '../../common/Spinner/Spinner';
import SearchItem from './SearchItem';
import districts from 'constants/Districts';
import { forcedSearchChange, setSearchValue, setSearchModalState } from '../../../actions/search';
import SearchFullscreen from 'components/SearchFullscreen';
import { getSearchValue, getSearch } from 'selectors/search';
import s from './styles';
import tracker from '../../../services/tracker';
import { withTranslation } from 'react-i18next';
import { gaEvent, trackGA } from 'services/ga';

class Search extends Component {

  constructor(props) {
    super(props);

    this.state = {
      // searchValue: ''
      // isFocused: false
    };

    this.setSearchValue = debounce(this.setSearchValue, 500);
  }

  onChange = (event) => {
    const { value } = event.target;
    // this.setState({ searchValue: value });
    this.setSearchValue(value);
    console.log(3);
  }

  setSearchValue = (value) => this.props.setSearchValue(value);

  handleIconClick = (event) => {
    const { forcedSearchChange } = this.props;
    forcedSearchChange(event.target.value);
    console.log(2);
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      const { forcedSearchChange } = this.props;
      const { value } = event.target;
      // this.setState({ searchValue: value });
      forcedSearchChange(value);
      document.activeElement.blur();
    }
  }

  handleWheel = (event) => {
    const { deltaY } = event;
    const menu = ReactDOM.findDOMNode(this.menuEl);
    const { clientHeight, scrollHeight, scrollTop } = menu;

    const moveUp = deltaY < 0;
    let stop;
    if (moveUp) {
      stop = scrollTop <= 0;
    } else {
      stop = scrollHeight - clientHeight - scrollTop <= 0;
    }
    if (stop) {
      event.preventDefault();
    }
  }

  onFocus = (e) => {
    e.stopPropagation();
    // this.setState({ isFocused: true });
    this.props.setSearchModalState(true);

    this.searchEl.blur();
  }

  onBlur = () => {
    // const { dispatch } = this.props;
    // // TODO Такое ощущение, что будто бы автокомплит пропадает раньше, чем
    // // срабатывает onClick на одном из его пунктов меню.
    // setTimeout(() => dispatch(changeFocus(false)), 300);
    // this.setState({ isFocused: false });
  }

  render() {
    const { className, search, searchValue, t, profile } = this.props;
    const { isLoading, autocomplete } = search;
    // const isFocused = this.state.isFocused;
    // const { searchValue } = this.state;
    const searchInputProps = {
      // onChange: this.onChange,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onClickContainer: this.onFocus,
      getRef: (searchEl) => { this.searchEl = searchEl; },
      onClick: this.onFocus,
      icon: <IconSearch
        onClick={this.handleIconClick}
        className={cx(s.Icon)}
      />,
      defaultValue: searchValue,
      disabled: false
    };
    const isBuildingsExists = autocomplete.buildings.length;
    const isSubregionsExists = autocomplete.subregions.length;
    const isRegionsExists = autocomplete.regions.length;

    return (
      <div className={cx(className, s.ContainerOuter)}>
        <SearchFullscreen />
        <div className={s.ContainerInner}>
          <div className={s.Search}>
            <div className={s.OnlyMobile}>
              <div onClick={this.onFocus}>
                <IconSearch
                  onClick={this.handleIconClick}
                  className={cx(s.Icon)}
                />
              </div>
              {/* <Input
                {...searchInputProps}
                placeholder={'Поиск'}
                className={cx(s.Input)}
              /> */}
            </div>
            <div className={s.MobileHidden}>
              <Input
                {...searchInputProps}
                placeholder={t('components.header.search.title')}
                className={s.Input}
                onFocus={() => {
                  tracker.sendEvent('Web_Search');
                  trackGA(gaEvent.headerButtonsClick({ eventLabel: 'poisk', user_id: profile.id }));
                }}
              />
            </div>
          </div>
          {/* <div
            className={cx(s.Menu, { [s.MenuHide]: !isFocused || !searchValue })}
            onWheel={this.handleWheel}
            ref={menu => { this.menuEl = menu; }}
          >
            <Spinner isLoading={isLoading && searchValue.length !== 0} noFadeIn>
              {(isBuildingsExists || isSubregionsExists || isRegionsExists) ? (
                <div>
                  {!!autocomplete.regions.length &&
                    <div>
                      <div className={s.NewTitle}>
                        Районы
                      </div>
                      <div className={s.SearchItems}>
                        {autocomplete.regions.map((a) =>
                          <SearchItem
                            key={a.id}
                            id={a.id}
                            ids={Object.keys(districts[a.id - 1].checkboxes)}
                            title={a.name}
                            isFilter
                          />
                        )}
                      </div>
                    </div>}
                  {!!isSubregionsExists &&
                    <div>
                      <div className={s.NewTitle}>
                        Микрорайоны
                      </div>
                      <div className={s.SearchItems}>
                        {autocomplete.subregions.map((a) =>
                          <SearchItem
                            key={a.id}
                            id={a.id}
                            ids={[a.id]}
                            title={a.name}
                            isFilter
                          />
                        )}
                      </div>
                    </div>}
                  {!!isBuildingsExists &&
                    <div>
                      <div className={s.NewTitle}>
                        Объекты
                      </div>
                      <div className={s.SearchItems}>
                        {autocomplete.buildings.map((a) =>
                          <SearchItem
                            key={a.id}
                            id={a.id}
                            title={a.name}
                            subregion={a.subregion}
                            address={a.address}
                          />
                        )}
                      </div>
                    </div>}
                </div>
                ) : <div className={s.NewTitle}>Ничего не найдено</div>
              }
            </Spinner>
          </div> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  search: getSearch(state),
  searchValue: getSearchValue(state),
  profile: state.profile
});

const mapDispatchToProps = {
  setSearchValue,
  forcedSearchChange,
  setSearchModalState
};

export default connect(
  mapStateToProps, mapDispatchToProps
)(withTranslation()(Search));



// WEBPACK FOOTER //
// ./src/components/Header/Search/Search.js